import React from 'react';
import { AppBar, Toolbar, Typography, Hidden } from '@material-ui/core';
import Logo from '../img/logo01.png';

function Header() {
    return (
        <AppBar position="static" className="header">
            <Toolbar variant="dense" className="content">
                <Typography variant="h6" color="inherit">
                    ゴム支承選定ナビゲーション
                </Typography>
                <Hidden xsDown>
                    <img src={Logo} alt=""/>
                </Hidden>
            </Toolbar>
        </AppBar>
    )
}

export default Header;
